module.exports = __webpack_public_path__ + "img/tit2@2x.bf5f3af0.png";